import { el } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import { TextareaInputBoxRow } from 'generics/components/text-input-row';
import SaveButton from 'generics/components/save-button';

import internalEventCodes from 'event-system/codes/internal';

import './index.scss';

class FeedbackForm {

  constructor(contentConfiguration, dialogConfiguration) {

    this.contentConfiguration = contentConfiguration;
    this.dialogConfiguration = dialogConfiguration;
    this.message = contentConfiguration.message;

    this.data = {
      message: ''
    };

    this.textareaInput = new TextareaInputBoxRow({
      placeholder: 'Share your thoughts on this response...',
      value: '',
      onChange: this.handleChange.bind(this)
    });

    this.submitButton = new SaveButton({
      type: 'submit',
      label: 'Submit',
      onClick: this.handleSubmit.bind(this)
    });

    this.el = el('form.feedback-form-main', {
      onsubmit: this.handleFormSubmit.bind(this)
    }, [
      this.textareaInput,
      el('.feedback-form-actions', [this.submitButton])
    ]);

  }

  handleFormSubmit(event) {

    event.preventDefault();

    this.submitButton.el.click();

  }

  onmount() {

    this.textareaInput.inputBox.focus();

  }

  handleChange(event, value) {

    this.data.message = value;

  }

  async handleSubmit() {

    const message = this.data.message;

    await serverInterface.startup.assistants.feedbacks.createFeedback({
      assistantRequestId: this.message.metadata.assistantRequest._id,
      message
    });

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: 'Feedback received!',
      seconds: 5,
      type: 'info'
    });

    this.dialogConfiguration.onComplete();

  }

}

export default FeedbackForm;